import yup from "src/utils/yup/extensionMethods";

const addOrChangeSchema = (translate: Function) => yup.object().shape({
	kba001Ativo: yup.boolean(),
	kba001Descricao: yup.string().required(translate("Descrição é requerida")),
	kba001Efa005Id: yup.number().required(translate("Responsável é requerido")),
	kba001Efa005Id2:  yup.number().required(translate("Autoridade é requerido")),
	kbtba003: yup.array().of(yup.object().shape({
		kba003Id: yup.string(),
		kba003Notificaparticipante: yup.string(),
		kba003Tipo: yup.string(),
		kba003Efa005Id: yup.string(),
		kba003Efa004Id: yup.string()
	}))
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.kba003Efa005Id, (a: any) => !a.kba003Efa004Id && a.kba003Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.kba003Efa005Id, (a: any) => !a.kba003Efa004Id && a.kba003Tipo === "I")
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.kba003Efa004Id, (a: any) => !a.kba003Efa005Id && a.kba003Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.kba003Efa004Id, (a: any) => !a.kba003Efa005Id && a.kba003Tipo === "I")
});


export default addOrChangeSchema;
